(function () {
  function initPromoPopup() {
    var overlay = document.getElementById('promo-popup-overlay');
    if (!overlay) return;

    if (sessionStorage.getItem('promoPopupShown')) return;

    function showPopup() {
      overlay.style.display = 'flex';
      overlay.classList.add('is-visible');
      sessionStorage.setItem('promoPopupShown', '1');
    }

    function hidePopup() {
      overlay.classList.remove('is-visible');
      overlay.style.display = 'none';
    }

    var closeBtn = overlay.querySelector('.promo-popup__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', hidePopup);
    }

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) {
        hidePopup();
      }
    });

    showPopup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPromoPopup);
  } else {
    initPromoPopup();
  }
})();
